import i18n from 'i18n';
import { format, startOfToday, differenceInSeconds } from 'date-fns';
import humanizeDuration from 'humanize-duration';

export const getFormattedDate = (date = '', dateFormat) => {
	return format(date ? new Date(date) : startOfToday(), dateFormat);
};

export const DATE_FORMAT = {
	DEFAULT: 'dd.mm.yyyy',
	MONTH_YEAR: 'MMM yyyy',
	HOURS_MIN: 'HH:mm',
	MOMENT_DEFAULT: 'YYYY-MM-DD',
	DAY_MONTH_YEAR: 'dd MMMM yyyy',
	DAY_MONTH_YEAR_FORMAT: 'dd.MM.yyyy',
	REGISTER_DATEPICKER_FORMAT: 'dd/MM/yyyy',
	DATE_WITH_TIME: 'dd.MM.yyyy HH:mm',
	LOCALE_DATE_FORMAT: 'dd.MM.yyyy HH:mm:ss',
	EPG_CALENDAR: 'dddd, DD MMMM YYYY'
};

export const convertDuration = (seconds, humanize = true) => {
	if (isNaN(seconds) || !humanize) return '';

	return humanizeDuration(seconds * 1000, {
		language: 'custom',
		units: ['h', 'm'],
		delimiter: ' ',
		maxDecimalPoints: 0,
		languages: {
			custom: {
				h: () => i18n.t('vod_movieDetails_hours'),
				m: () => i18n.t('vod_movieDetails_minutes')
			}
		}
	});
};

export const convertDatesToBroadcastHours = (...dates) =>
	dates
		.map((date) => (date ? format(new Date(date), DATE_FORMAT.HOURS_MIN) : ''))
		.join(' - ');

export const getLiveDuration = (since, till) => {
	if (!since || !till) return 0;
	return differenceInSeconds(new Date(till), new Date(since));
};

export const convertDateToLocale = (date) =>
	new Date(date).toLocaleDateString(i18n.language, {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
	});

export const convertDateToYearMonthDay = (date) =>
	date ? format(date, 'YYYY-MM-DD') : '-';

export const getTimeLineFormat = (currentTime) => {
	const formatTime = (time) => (time >= 10 ? time : `0${time}`);
	const hours = Math.floor(currentTime / 60 / 60);
	const minutes = Math.floor(currentTime / 60) - hours * 60;
	const seconds = Math.floor(currentTime % 60);
	return `${formatTime(hours)}:${formatTime(minutes)}:${formatTime(seconds)}`;
};
